module.exports = "/assets/data/8f94fb9a9299f14d82c4520d35ddbdc8-SW18.data.json";